






















import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class AddTabDialog extends Vue {
  @Prop({ default: false }) value!: boolean;

  public tabName: string = "";

  public get internalShow(): boolean {
    return this.value;
  }

  public set internalShow(val: boolean) {
    this.$emit("input", val);
  }

  @Watch("value")
  onValueChanged(newVal: boolean) {
    if (!newVal) {
      this.tabName = "";
    }
  }

  public addTab() {
    if (this.tabName.trim()) {
      this.$emit("add-tab", this.tabName.trim());
      this.close();
    }
  }

  public close() {
    this.tabName = "";
    this.$emit("input", false);
  }
}
